import { render } from "./About.vue?vue&type=template&id=691a7c5a&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=691a7c5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-691a7c5a"

export default script